module.exports = __webpack_public_path__ + "static/img/korea.74e98a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/korea.png
// module id = 258
// module chunks = 0